import { Theme } from '@mui/material/styles'

const useStyles = {
  toggleButtonGroup: (theme: Theme) => ({
    gap: theme.spacing(4),
  }),
  toggleButton: (theme: Theme) => ({
    border: '1px solid transparent',
    borderRadius: theme.shape.extraLargeBorderRadius,
    backgroundColor: theme.palette.background.paper,
    padding: '6px 8px',
    color: theme.palette.text.primary,
    textTransform: 'none',

    '&.MuiToggleButtonGroup-grouped:not(:last-of-type), &.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
      borderRadius: theme.shape.extraLargeBorderRadius,
    },
    '&.Mui-selected, &.MuiToggleButtonGroup-grouped:not(:first-of-type).Mui-selected, &.MuiToggleButtonGroup-grouped.Mui-selected+.MuiToggleButtonGroup-grouped.Mui-selected':
      {
        border: `1px solid ${theme.palette.primary.light}`,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.dark,
        '&:hover': {
          backgroundColor: theme.palette.background.paper,
        },
      },
    '&:hover': {
      backgroundColor: 'inherit',
    },
  }),
}
export default useStyles
